import styled from "styled-components";

export const Box = styled.div`
    height: 100vh;
    width: 100%;
    background-color: black;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`;

export const Logo = styled.img`
    height: 100px;
`;

export const XLogo = styled.img`
    height: 100px;
`;

export const A = styled.div`
    font-weight: bold;
    font-size: xxx-large;
`;

export const B = styled.div`
    font-size: large;
`;